export default {
  path: '/lvy-notary-service-agreement',
  component: () => import('./LvyNotaryServiceAgreement'),
  meta: {
    title: '前海公证处服务协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}